/**
 * Powers fields for Uber Tracking Links
 *
 * @author (Paige) pponzeka@yext.com
 */
goog.module('yext.location.UberLaunchLink');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const Select = goog.require('yext.location.Select');
const textfield = goog.require('yext.textfield');

/**
 * @constructor
 */
const UberLaunchLink = function($field) {
  this.$ctxt = $field;
  this.select = new Select(this.$ctxt.find('.js-select-wrap'));
  this.textfield = textfield.create(this.$ctxt.find('.js-text-field'));
  this.$previewContainer = this.$ctxt.find('.js-input-preview');
  this.buttonPreview = this.$previewContainer.find('.js-button-preview').clone().show();
  this.$launchLinkMessage = $field.find('.js-launchlink-message');
  this.$fieldValue = this.$ctxt.find('.js-field-value');
  this.indeterminate = this.$ctxt.data('indeterminate');
  this.timestamp = this.$ctxt.data('timestamp');

  this.bindUpdate();
  this.storeValue();
  this.bindIndeterminate();
  this.updateVisibleInputs();
  this.setFieldValue();
};

/**
 * Sets the value and then calls toggleIndeterminate to update the UI
 *
 * @param {boolean} indeterminate
 */
UberLaunchLink.prototype.setIndeterminate = function(indeterminate) {
  this.indeterminate = indeterminate;
  this.toggleIndeterminate(indeterminate);
};


/**
 * Bind the indeterminate reset link
 */
UberLaunchLink.prototype.bindIndeterminate = function() {
  var self = this;
  this.$ctxt.find('.js-reset-indeterminate').click(function() {
    self.toggleIndeterminate(false);
  });
};

/**
 * Toggles the UI indeterminate state
 *
 * @param {boolean} indeterminate
 */
UberLaunchLink.prototype.toggleIndeterminate = function(indeterminate) {
  this.$ctxt.find('.js-indeterminate-message').toggle(indeterminate);
  this.$ctxt.closest('.field-content').find('.js-show-when-determinate').toggle(!indeterminate);
  this.$launchLinkMessage.toggle(!indeterminate);
};

/**
 * Trigger the field as updated then the textfield or the select field sends an update event
 */
UberLaunchLink.prototype.bindUpdate = function() {
  var self = this;

  $(this.select).on('updated', function() {
    $(self).trigger('updated');
  });

  $(this.textfield).on('update.textField', function() {
    $(self).trigger('updated');
  });

  $(this).on('updated', function() {
    self.updatePreview();
    self.updateVisibleInputs();
    self.setFieldValue();
  });
};

/**
 * updates the preview for the input
 */
UberLaunchLink.prototype.updatePreview = function() {
  var previewHtml; var markup;

  if (this.textfield.isEmpty()) {
    markup = yext.msg('Ride here with Uber');
  } else {
    markup = this.textfield.model.value;
  }

  if (this.isLink()) {
    previewHtml = '<a href="#">' + markup + '</a>';
  } else {
    previewHtml = {
      content: this.buttonPreview,
    };
  }

  this.$previewContainer.html(previewHtml.content);
};

/**
 * Updates the visible inputs for link or butt view
 */
UberLaunchLink.prototype.updateVisibleInputs = function() {
  if (this.isLink()) {
    this.textfield.show();
  } else {
    this.textfield.hide();
  }
};

/**
 * @return {boolean} returns true if the selected is a link
 */
UberLaunchLink.prototype.isLink = function() {
  return this.select.getValue() === 'LINK';
};

/**
 * Reset the field to the stored state
 */
UberLaunchLink.prototype.reset = function() {
  this.select.reset();
  this.textfield.reset();
  this.setIndeterminate(this.storedIndeterminate);

  $(this).trigger('updated');
};

/**
 * Set the select element value and trigger a change event
 *
 * @param {!Object} value
 */
UberLaunchLink.prototype.set = function(data) {
  this.textfield.set(data['text']);
  this.select.set(data['presentation']);
  this.setIndeterminate(data['indeterminate']);
  this.timestamp = data['timestamp'];

  $(this).trigger('updated');
};

/**
 * Store the value so that it can be restored later
 */
UberLaunchLink.prototype.storeValue = function() {
  this.textfield.saveValue();
  this.select.storeValue();
  this.storedIndeterminate = this.indeterminate;
};

UberLaunchLink.prototype.setFieldValue = function() {
  this.$fieldValue.val(window.JSON.stringify(this.getJSONData()));
};

UberLaunchLink.prototype.getJSONData = function() {
  return {
    'text': this.textfield.coreData(),
    'presentation': this.select.getData(),
    'indeterminate': this.indeterminate,
    'timestamp': this.timestamp,
  };
};


exports = UberLaunchLink;
